const STORAGE_KEY = "ht_user_init_data";
const MAX_AGE_MS = 45 * 60 * 1000; // 45 minutes

/**
 * Stores pre-fetched user init data in sessionStorage.
 * Converts Sets to arrays for JSON serialization.
 */
export const storeUserInitData = ({
  userInfo,
  allowSet,
  denySet,
  rolePermissions,
}) => {
  try {
    const data = {
      userInfo,
      allowSet: [...allowSet],
      denySet: [...denySet],
      // Raw rolePermissions are needed by @hoteltradergit/user-management, which re-parses
      // them itself (the allow/deny sets above are only for this app's own RBAC). Without it
      // the package sees [] on the cache-hydrated first render and hides its nav (Manage Users).
      rolePermissions: rolePermissions ?? [],
      timestamp: Date.now(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage full or unavailable — silently ignore
  }
};

/**
 * Reads pre-fetched user init data from sessionStorage.
 * Returns { userInfo, allowSet, denySet, rolePermissions } or null if missing/expired.
 */
export const readUserInitData = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const data = JSON.parse(raw);
    if (Date.now() - data.timestamp > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return {
      userInfo: data.userInfo,
      allowSet: new Set(data.allowSet),
      denySet: new Set(data.denySet),
      rolePermissions: data.rolePermissions ?? [],
    };
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

/**
 * Removes the pre-fetched user init data from sessionStorage.
 */
export const clearUserInitData = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
